import React, { useState, useEffect, useRef } from "react";
import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Empty, Select, Pagination, Tooltip, Input } from "antd";

import RTableSelectable from "../../RTableSelectable";
import CandidateAddModal from "../../CandidateAddModal";
import TextFilter from "../../textFilter";
import LexicalSort from "../../lexicalSort";
import NumericFilter from "../../numericFilter";
import useCandidateStore from "../../../store/candidateModal.store";
import useMembersStore from "../../../store/members.store";
import "./nuJobsReceivedApplications.scss";
import cloudIcon from "../../../assets/upload.png";
import caution from "../../../assets/caution.png";
import PieChart from "../../PieChart";
import useResumeStore from "../../../store/resume.store";
import useStatsStore from "../../../store/stats.store";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  LeftOutlined,
  RightOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";


import { FILTER_DURATION_OPTIONS, OWNERSHIP_OPTIONS, VIEW_FILTER_CONFIG } from "../../../helper/categoryconstants";
import { CHECKBOX_WIDTH, COMMUNICATION_COLUMNS_WIDTH, CTC_COLUMNS_WIDTH, DETAILS_COLUMNS_WIDTH, HIRING_FLOW_COLUMNS_WIDTH, NU_JOBS_DETAILS_COLUMNS_WIDTH, NUJOBS_PERSONAL_DETAIL_COLUMNS_WIDTH, PERSONAL_DETAIL_COLUMNS_WIDTH, RESUME_ANALYSIS_COLUMNS_WIDTH, SOURCING_TABLE_COLUMNS_WIDTH, SUMMARY_COLUMNS_WIDTH } from "../../../helper/tablewidthcontants";
import useJDStore from "../../../store/jd.store";
import { GetSourceOwner } from "../../../helper/commonFunctions";

const { Search } = Input;

const summaryListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",    
    "Name", 
    'Email', 
    "Mobile",                    
    "Current Location",
    "Preferred Location",
    "Total Exp",
    "Current CTC",
    "ECTC",
    "Notice Period", 
    "LWD",        
    "Remarks",
    "Applied By",
    "Applied On",
];

const personalListTable = [
    "Sr. No.",
    "Resume ID",
    "Name",
    "Email Id",
    "Mobile",
    "Aadhar ID",
    "Gender",
    "Current Location",
    "Preferred Location",
    "Designation",
    "Company",
    "Max Degree",
    "Stream",
    "Passing Year",
];

const communicationListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",    
    "Name",  
    "Email",
    "Phone",
    "Resume Suitability",    
    "Candidate Status", 
    "Extra Analysis",              
    "Resume Status",
    "Candidate Interest Mails",
    "Slot Mails",
    "Interview Reminder Mails",
    "Feedback Reminder Mails"
];


export default function NuJobsReceivedApplications() {
  const [currentView, setCurrentView] = useState("summary");
  const [previousView, setPreviousView] = useState("");
  const [currentFiltersToView, setCurrentFiltersToView] = useState([]);
  const [currentViewFilters, setCurrentViewFilters] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedResumeID, setResumeID] = useState("");
  const { selectedJD,updateResumesVersion} = useJDStore();
  const navigate = useNavigate();
  const location = useLocation();
  const { value,product } = useParams();
  const { teamMembers } = useMembersStore();
  const scrollRef = useRef(null);
  var dbVersion = JSON.parse(localStorage.getItem("dbversions"))
  const updatedByList =
    teamMembers?.map((member) => ({
      value: member?.username,
      label: member?.username,
    })) || [];
  const loggedInUser = JSON.parse(localStorage.getItem("userDetails")).username;

  const pathSegments = location.pathname.split("/");
  const parentPath = pathSegments[1];

  const currentProduct = product || "qhrflow";
  const isNuJobsPost = currentProduct === "nujobs";

  useEffect(() => {
    if (currentFiltersToView.length == 0) {
      setSearchInput("");
    }
  }, [currentFiltersToView]);


  const [filterApiParameters, setFilterApiParameters] = useState({
    search: "",
    sortBy: "",
    sortOrder: "",
    "Total Experience": "All",
    "Relevant Experience": "All",
    "Current CTC": "All",
    ECTC: "All",
    "Notice Period": "All",
    "Candidate Status": [],
    "Resume Suitability": [],
    "Resume Status": [],
    "Education Analysis": [],
    "Experience Analysis": [],
    "Parsing Errors": [],
    Gender: [],
    "Reason For Leaving": [],
    "Reason For Not Working": [],
    "Other Offers": [],
    Payroll: [],
    "Skill Matrix Suitability": [],
    "Assessment Suitability": [],
    "Interview Status": [],
    "Interview Type": [],
    "Offer Status": [],
     Ownership: ['By Candidate'],
    "Source By": [],
    "Updated By": [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const { setCandidateModalOpen } = useCandidateStore();
  const [importRefreshFlag, setImportRefreshFlag] = useState(false);
  const [durationChange, setDurationChange] = useState(false);
  const {
    resumes,
    getResumesByJD,
    updateResume,
    downloadResumeByID,
    allApplications,
    getAllApplicationsByJD,
    setUpdateFlag,
    updateFlagSpecific,
    resetUpdateFlagSpecific,
    resetSelectedProfileResume,
    resetSelectedApplication,
    updateFlag,
    resetUpdateFlag,
    selectedJDMapData,
    totalapplications,
  } = useResumeStore();

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };
  const setFilterParameters = (newFilters) => {
    setFilterApiParameters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));

  };
  const [previousFilterState, setPreviousFilterState] = useState(null);

  const pullAvailableData = () => {
    // Store current filter state before changing to Available
    //console.log("Storing previous filter state in pull:", filterApiParameters);
    
    // Store the current state before updating
    const currentState = { ...filterApiParameters };
    setPreviousFilterState(currentState);
    
    setFilterApiParameters(prevFilters => ({
      ...prevFilters,
    }));
  };

  const restorePreviousData = () => {
     //console.log("Restoring previous filter state:", previousFilterState);
      // If no previous state, just remove "Available" from current filters
      setFilterApiParameters(prevFilters => ({
        ...prevFilters,
        "Candidate Status": prevFilters["Candidate Status"].filter(status => status !== "Available")
      }));
    setPreviousFilterState(null); // Clear stored state after restoring
    
  };

  useEffect(() => {  
    //console.log("User Effects for init and filter change", filterApiParameters);
    getAllApplicationsByJD(value, filterApiParameters, currentPage, pageSize,localStorage.getItem("sourcing.duration"));
  }, [filterApiParameters, currentPage, pageSize, importRefreshFlag]);

  useEffect(() => {
    resetUpdateFlag();
  }, []);

    useEffect(() => {
        if(updateFlag || updateFlagSpecific || durationChange){
            //getResumesByJD(value);
            //console.log("Fetching all applications due to update flag");
            getAllApplicationsByJD(value, filterApiParameters, currentPage, pageSize,localStorage.getItem("sourcing.duration"));
            resetUpdateFlag()
            resetUpdateFlagSpecific()
            setDurationChange(false)
        }
    }, [updateFlag,updateFlagSpecific,durationChange]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const checkScroll = () => {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    checkScroll();
    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  const scroll = (direction) => {
    const el = scrollRef.current;
    const scrollAmount = 95;
    if (direction === "left") el.scrollLeft -= scrollAmount;
    else el.scrollLeft += scrollAmount;
  };
    const handleDownloadResume = (resumeID) => {
        downloadResumeByID(value, resumeID);
    };


   const GetUpdatedByDetails = (qhrid)=>{
    for(let idx = 0; idx < allApplications?.length; idx++){  
        if (allApplications[idx]?.qhrid === qhrid) {               
            return {
                updatedByName:allApplications[idx]?.candidatestatus?.updatedby.name,
                updatedOn:allApplications[idx]?.candidatestatus?.updatedby.updatedon,
                status:allApplications[idx]?.candidatestatus?.status
        } 
       }
     }
   }
   const GetResumeScore = (qhrid)=>{
    for(let idx = 0; idx < allApplications?.length; idx++){  
        if (allApplications[idx]?.qhrid === qhrid) {   
            return ({
                finalScore: allApplications[idx]?.resumescore.score
        }) 
       }
     }
   }
   
   const GetNoticePeriod = (qhrid)=>{
    for(let idx = 0; idx < resumes?.length; idx++){  
        if (resumes[idx]?.qhrid === qhrid) {
            return ({
                officialnp: resumes[idx]?.employmentdetails.noticeperiod.officialnp,
                lwd: resumes[idx]?.employmentdetails.noticeperiod.lwd
        }) 
       }
     }
   }

   function GetResumeDetails(qhrid){
    for(let idx = 0; idx < resumes?.length; idx++){  
        if (resumes[idx]?.qhrid === qhrid) {
            return (
                 resumes[idx]
        ) 
       }
     }
   }
   const GetLastUpdated = (appDetail)=>{
        if(appDetail.resumestatus.updatedby.timestamp === 0 ){
            return ({
                updatedBy: appDetail.candidatestatus.updatedby.name,
                updatedOn: appDetail.candidatestatus.updatedby.updatedon
        })
        }
        else if (appDetail.candidatestatus.updatedby.timestamp > appDetail.resumestatus.updatedby.timestamp) {  
            return ({
                updatedBy: appDetail.candidatestatus.updatedby.name,
                updatedOn: appDetail.candidatestatus.updatedby.updatedon
        }) 
       }else{
        return ({
            updatedBy: appDetail.resumestatus.updatedby.name,
            updatedOn: appDetail.resumestatus.updatedby.updatedon
        })
       }
   }

   const GetLastUpdatedSelections = (appDetail)=>{

    //find which one is latest timestamp
    if((appDetail?.selectionstatus?.updatedby.timestamp > appDetail?.bgvstatus?.updatedby.timestamp )
        && (appDetail?.selectionstatus?.updatedby.timestamp > appDetail?.documentsstatus?.updatedby.timestamp )){
        return ({
            updatedBy: appDetail?.selectionstatus?.updatedby.name,
            updatedOn: appDetail?.selectionstatus?.updatedby.updatedon,
            remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
    }
    else if((appDetail?.bgvstatus?.updatedby.timestamp > appDetail?.selectionstatus?.updatedby.timestamp )
        && (appDetail?.bgvstatus?.updatedby.timestamp > appDetail?.documentsstatus?.updatedby.timestamp )){
        return ({
            updatedBy: appDetail?.bgvstatus?.updatedby.name,
            updatedOn: appDetail?.bgvstatus?.updatedby.updatedon,
            remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
    }else if((appDetail?.documentsstatus?.updatedby.timestamp > appDetail?.selectionstatus?.updatedby.timestamp )
        && (appDetail?.documentsstatus?.updatedby.timestamp > appDetail?.bgvstatus?.updatedby.timestamp )){
        return ({
            updatedBy: appDetail?.documentsstatus?.updatedby.name,
            updatedOn: appDetail?.documentsstatus?.updatedby.updatedon,
            remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
    } else{
    return ({
        updatedBy: appDetail?.selectionstatus?.updatedby.name,
        updatedOn: appDetail?.selectionstatus?.updatedby.updatedon,
        remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
   }
}
   const GetApplicationData = (qhrid)=>{
    for(let idx = 0; idx < allApplications?.length; idx++){  
        if (allApplications[idx]?.qhrid === qhrid) {   
            return allApplications[idx] 
        }
        return null
     }
     return null
    } 
    const GetPreferredLocation = (appDetail)=>{
        var loc =""
        for(let idx = 0; idx < appDetail?.newemploymentdetails?.preferredlocation?.length; idx++){
            if(idx >0){
                loc = loc + ","
            }  
            loc = loc + appDetail?.newemploymentdetails?.preferredlocation?.[idx]
            return loc
         }
         return loc
        } 

    function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }   
  const extraAnalysisData = (extraanalysis) =>{
      let str = "Suitable";
      if(extraanalysis?.ishighctc ){
        str = "HCTC"
      }
      if (extraanalysis?.ishighnp){
        if(str == "HCTC") {
          str = str + " / "         
          str = str + "HNP"
        }else{
          str = "HNP"
        }
      }
      return str
  }
    const summaryDataNew = allApplications?.map((appDetail, idx) => {
        let nPeriod = GetNoticePeriod(appDetail?.qhrid) 
        let lUpdate = GetLastUpdated(appDetail)   
        var resumeDetail = GetResumeDetails(appDetail?.qhrid)
        //console.log("Summary New Data current page",currentPage,pageSize)
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name, 
            email: appDetail?.applicationid.email,
            mobile: appDetail?.applicationid.mobile,                                       
            currentLocation: resumeDetail?.employmentdetails?.currentlocation,     
            preferredLocation: appDetail?.newemploymentdetails?.preferredlocation !=null ? appDetail?.newemploymentdetails?.preferredlocation:"--",                             
            totalexp: appDetail?.newemploymentdetails.totalexp,
            cCTC: resumeDetail?.employmentdetails.currentctc?.totalctc,
            ECTC: appDetail?.newemploymentdetails.ectc.totalctc,
            noticePeriod: nPeriod?.officialnp == 1024?"":nPeriod?.officialnp, 
            lwd: nPeriod?.officialnp == 1024?"":nPeriod?.lwd,        
            candidateComments: appDetail?.candidatestatus.updatedby.remarks,
            uploadedBy: appDetail?.candidatestatus.updatedby.name,
            dateAdded: formatUnixDate(appDetail?.candidatestatus.updatedby.timestamp),
    };
  });

  const personalDetailsData = allApplications?.map((appDetail, idx) => {
    var resumeDetail = GetResumeDetails(appDetail?.qhrid);
    var pLoc = GetPreferredLocation(appDetail);

        return {
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:resumeDetail?.qhrid,
            name: resumeDetail?.personaldetail.name,
            email: resumeDetail?.personaldetail.email,
            phone: resumeDetail?.personaldetail.mobile,
            aadhar: resumeDetail?.personaldetail.aadharid,
            gender: resumeDetail?.personaldetail.gender,
            currentLocation: resumeDetail?.employmentdetails?.currentlocation, 
            preferredLocation: appDetail?.newemploymentdetails?.preferredlocation !=null ? appDetail?.newemploymentdetails?.preferredlocation:"--",          
            currentDesignation: resumeDetail?.employmentdetails.designation,
            currentCompany: resumeDetail?.employmentdetails?.currentcompany,
            maxDegree: resumeDetail?.educationaldetail.maxdegree,
            stream: resumeDetail?.educationaldetail.stream, 
            passoutyear: resumeDetail?.educationaldetail.passoutyear,           
        };
    });    

   

    const colorData = allApplications?.map((appDetail, idx) => {
        var method =appDetail?.sourcingdetails?.method
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            color: "#f3f7fa"
        };
    });


    const handleResumeProfile= (jdId,id,rid) => {
        resetSelectedProfileResume (value,rid)
        resetSelectedApplication (value,rid)
        setResumeID(rid)
    };


    const handleCurrentViewProfile = () =>{
    setPreviousView(currentView);
    setCurrentView("profile");
  };


    const handleResumeVersionUpgrade = () =>{
        updateResumesVersion(value) 
    }

    const handleDuration =(dur)=>{
        //console.log("Current sourcing duration", dur)
        localStorage.setItem("sourcing.duration", dur);
        setDurationChange(true)
      }
    const getDurationlabel =()=>{     
         var dur = localStorage.getItem("sourcing.duration")
         if(dur =="All"){
           return 'All Resumes'
         }else {
           var durInt = parseInt(dur, 10)
           if( durInt < 48){
              return 'Updated in Last '+ dur + ' hrs'
           }else
            return 'Updated in Last '+ dur/24 + ' days'
         }
      }

  const handleSearch = () => {
    setFilterApiParameters((prevFilters) => ({
      ...prevFilters,
      search: searchInput,
    }));
  };

  
  const handleProfileBackBtn = () => {
    if(isNuJobsPost == true){
        navigate(`/${parentPath}/${value}/nujobs`);
    }else{
        navigate(`/jds/${value}`);
    }

    setCurrentView(previousView);
  };

  return (
    <div className="jd-summary-wrapper">
      {currentView !== "profile" && (
        <>
            <div className="section-header">
                   <h3 className="title">NuJobs Applicants {" (" + totalapplications+ ") "}</h3>
	            <div className="section-header-input">
	              <Search
	                placeholder="Search by Name/Mobile/Email/Resume ID"
	                size="small"
	                value={searchInput}
	                onChange={(e) => setSearchInput(e.target.value)}
	                onSearch={handleSearch}
	                style={{ width: 350, height: 24, marginRight: 12 }}
	              />
                    <Select
                        style={{ width: 230,height: 24 }}
                        onChange={handleDuration}
                        showSearch={true}
                        filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}                  
                        placeholder={getDurationlabel()}                                                  
                        options={FILTER_DURATION_OPTIONS} 
                    /> 
                   </div>
                {
                   selectedJD?.SupportedResumeDBVersion != dbVersion?.resumedbversion?
                   <>
                      <Button
                          onClick={handleResumeVersionUpgrade}
                          className="btn"
                          type="primary"
                      >
                          <img
                              src={caution}
                              alt="Upload"
                              width="30" height="30"
                              className="image"
                          />
                          Update Needed
                      </Button>   
                   </>
                   :<></>
                }             
          </div>
          <div className="jd-summary-buttons-wrapper-container">
            {canScrollLeft && (
              <div
                className="jd-summary-arrow-btn"
                onClick={() => scroll("left")}
              >
                <LeftOutlined />
              </div>
            )}
            <div className="jd-summary-buttons-wrapper" ref={scrollRef}>
                <Button
                    className={`jd-summary-btn ${
                        currentView === "summary" && "jd-summary-btn-active"
                    }`}
                    onClick={() => setCurrentView("summary")}
                >
                    Summary
                </Button>
              <Button
                className={`jd-summary-btn ${
                  currentView === "personal" &&
                  "jd-summary-btn-active"
                }`}
                onClick={() => setCurrentView("personal")}
              >
                Personal Details
              </Button>
              <Button
                className={`jd-summary-btn ${
                  currentView === "communications" && "jd-summary-btn-active"
                }`}
                onClick={() => setCurrentView("communications")}
              >
                Communications
                </Button>  

            </div>{" "}
            {canScrollRight && (
              <div
                className="jd-summary-arrow-btn"
                onClick={() => scroll("right")}
              >
                <RightOutlined />
              </div>
            )}
          </div>
          <div className="resumes-info-wrapper">
          </div>
        </>
      )}
      {resumes ? (
        <div className="jd-summary-container">
          {currentView === "charts" ? (
             <h4 style={{margin: "50px"}}>Upgrade to QHRFLOW For Analytics</h4>
          ) : currentView === "summary-status" ? (
             <h4 style={{margin: "50px"}}>Upgrade to QHRFLOW For Hiring Flow</h4>
          ) : currentView === "resume_analysis_table" ? (
             <h4 style={{margin: "50px"}}>Upgrade to QHRFLOW For Resume Analysis</h4>
          ) : currentView === "personal" ? (
            <RTableSelectable
              isClickable
              titleList={personalListTable}
              data={personalDetailsData}
              colorData = {colorData} 
              isResumePage
              isEditField={false}
              setCurrentView={handleCurrentViewProfile}
              resumeProfileHandler={handleResumeProfile}
              filterParameters={filterApiParameters}
              setFilterParameters={setFilterParameters}
              setImportRefreshFlag={setImportRefreshFlag}                
              jdID={value}
              columnWidth={NUJOBS_PERSONAL_DETAIL_COLUMNS_WIDTH}
              viewname={"NuJobsReceivedApplications"}
            />            
          ) : currentView === "profile" ? (
            <>
              <Outlet context={{ handleProfileBackBtn }} />
            </>
          ) : currentView === "communications" ? (
                 <h4 style={{margin: "50px"}}>Upgrade to QHRFLOW For  Candidate Communications</h4>
          ) : (
            <>
              <RTableSelectable
                isClickable={true}
                isResumePage
                titleList={summaryListTable}
                data={summaryDataNew}
                isEditField={true}
                colorData = {colorData}
                setCurrentView={handleCurrentViewProfile}
                resumeProfileHandler={handleResumeProfile}
                filterParameters={filterApiParameters}
                setFilterParameters={setFilterParameters}
                setImportRefreshFlag={setImportRefreshFlag}
                qhjid={value}
                selectable={"C Only"}
                ignoreDeleteAction = {true}  
                columnWidth={[CHECKBOX_WIDTH,...NU_JOBS_DETAILS_COLUMNS_WIDTH]}
                viewname={"NuJobsReceivedApplications"}
              />
            </>
          )}
          {currentView !== "profile" && (
            <Pagination
              style={{
                marginTop: "4px",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "16px",
                marginBottom: "10px",
              }}
              current={currentPage}
              pageSize={pageSize}
              total={totalapplications}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
            />
            )}
        </div>
        ) : (
                <>
                  <RTableSelectable
                    isClickable={true}
                    isResumePage
                    titleList={null}
                    data={null}
                    isEditField={true}
                    setCurrentView={handleCurrentViewProfile}
                    resumeProfileHandler={handleResumeProfile}
                    filterParameters={filterApiParameters}
                    setFilterParameters={setFilterParameters}
                    setImportRefreshFlag={setImportRefreshFlag}
                    qhjid={value}
                    columnWidth={[
                      50, 50, 100, 200, 300, 100, 100, 80, 80, 80, 80, 80, 80, 200,
                      200, 100, 100, 100,
                    ]}
                    viewname={"NuJobsReceivedApplications"}
                  />
                  <Empty style={{ margin: "60px" }} >
                      <h4>No Applications Received yet</h4>
                  </Empty>                  
                </>              
            )}

            <CandidateAddModal />
         
        </div>
    );
}
